import hexRgba from "hex-rgba";

function quoteStyles() {
  return {
    restrict: "A",
    scope: {
      sectionIndex: "=",
      section: "=",
      branding: "=",
    },
    link: function (scope) {
      const generateStyle = function (
        quoteDesignElement,
        element,
        hasBackground
      ) {
        const organizationBranding = scope.branding;
        const fontColor = hasBackground ? "#ffffff" : false;

        return `
          font-family: ${
            quoteDesignElement.font.family
              ? quoteDesignElement.font.family
              : organizationBranding[element].font.family
          };
          font-size: ${
            quoteDesignElement.size || organizationBranding[element].size
          }px;
          color: ${
            quoteDesignElement.color ||
            fontColor ||
            organizationBranding[element].color
          };
        `;
      };

      const generateCustomPlaceholderStyle = function (
        quoteDesignElement,
        element,
        hasBackground
      ) {
        const organizationBranding = scope.branding;
        const fontColor = hasBackground ? "#ffffff" : false;

        return `
          background-color: ${
            quoteDesignElement.color
              ? hexRgba(quoteDesignElement.color, 20)
              : quoteDesignElement.color || fontColor
              ? hexRgba(fontColor, 20)
              : fontColor || organizationBranding[element].color
              ? hexRgba(organizationBranding[element].color, 20)
              : organizationBranding[element].color
          };
        `;
      };

      const generateLinkStyle = function () {
        return `
          color: inherit !important;
          text-decoration: underline;
        `;
      };

      const generatePricingTablePreviewStyle = function (element, opacity) {
        const organizationBranding = scope.branding;
        return `
          background-color: ${
            scope.section.style[element].color
              ? hexRgba(scope.section.style[element].color, opacity)
              : hexRgba(organizationBranding[element].color, opacity)
          }
        `;
      };

      const generatePricingTablePreviewHeaderStyle = function (
        element,
        opacity
      ) {
        const organizationBranding = scope.branding;
        return `
          font-weight: bold;
          color: ${
            scope.section.style[element].color
              ? hexRgba(scope.section.style[element].color, opacity)
              : hexRgba(organizationBranding[element].color, opacity)
          }
        `;
      };

      const generatePricingTablePreviewHRStyle = function () {
        const organizationBranding = scope.branding;
        return `
          margin-top: 3rem;
          margin-bottom: 0rem;
          border: 0;
          border-top: 1px solid ${
            scope.section.style.header1.color
              ? scope.section.style.header1.color
              : organizationBranding.header1.color
          };
        `;
      };

      const generateBorderTableStyle = function (hasBackground) {
        const organizationBranding = scope.branding;
        if (!hasBackground)
          return `border-bottom: 1px ${
            scope.section.style.text.color
              ? hexRgba(scope.section.style.text.color, 30)
              : hexRgba(organizationBranding.text.color, 30)
          } solid;`;
        else
          return `border-bottom: 1px ${
            scope.section.style.text.color
              ? hexRgba(scope.section.style.text.color, 70)
              : "rgba(255, 255, 255, 0.7)"
          } solid;`;
      };

      const background = function (style) {
        const organizationBranding = scope.branding;
        let backgroundColor;

        switch (style.backgroundColorType) {
          case "primary":
            backgroundColor = organizationBranding.header1.color;
            break;
          case "secondary":
            backgroundColor = organizationBranding.header2.color;
            break;
          case "none":
            backgroundColor = "#FFFFFF00";
            break;
          case "custom":
            backgroundColor = style.backgroundColor;
            break;
        }

        let backgroundStyle = `
          background-size: cover !important;
          background: linear-gradient(${backgroundColor}, ${backgroundColor}), url('${style.backgroundImage}') no-repeat center;
        `;

        if (style.size === "full")
          backgroundStyle = backgroundStyle + "min-height: calc(100vh - 70px);";

        return backgroundStyle;
      };

      const generateStyleTag = function () {
        const style = $('<style type="text/css"></style>');
        const prefix = `section.quote-section.quote-section-${scope.sectionIndex}`;
        const hasBackground = scope.section.hasBackground();

        // ${prefix} .normalized-quote-styles table tbody td {${generateBorderTableStyle(hasBackground)}}
        style.html(`
          ${prefix} .normalized-quote-styles h1 {${generateStyle(
          scope.section.style.header1,
          "header1",
          hasBackground
        )}}
          ${prefix} .normalized-quote-styles h2 {${generateStyle(
          scope.section.style.header2,
          "header2",
          hasBackground
        )}}
          ${prefix} .normalized-quote-styles h1 .custom-placeholder{${generateCustomPlaceholderStyle(
          scope.section.style.header1,
          "header1",
          hasBackground
        )}}
          ${prefix} .normalized-quote-styles h2 .custom-placeholder{${generateCustomPlaceholderStyle(
          scope.section.style.header2,
          "header2",
          hasBackground
        )}}
          ${prefix} .normalized-quote-styles p,
          ${prefix} .normalized-quote-styles td, 
          ${prefix} .normalized-quote-styles ul, 
          ${prefix} .normalized-quote-styles ol {${generateStyle(
          scope.section.style.text,
          "text",
          hasBackground
        )}}
          ${prefix} .normalized-quote-styles p .custom-placeholder,
          ${prefix} .normalized-quote-styles td .custom-placeholder, 
          ${prefix} .normalized-quote-styles ul .custom-placeholder, 
          ${prefix} .normalized-quote-styles ol .custom-placeholder {${generateCustomPlaceholderStyle(
          scope.section.style.text,
          "text",
          hasBackground
        )}}
          ${prefix} .normalized-quote-styles a {${generateLinkStyle()}}
          ${prefix} .pricing-table-preview table {${generateStyle(
          scope.section.style.text,
          "text",
          hasBackground
        )}}  
          ${prefix} .pricing-table-preview th {${generatePricingTablePreviewHeaderStyle(
          "header1",
          0
        )}}          
          ${prefix} .pricing-table-preview hr {${generatePricingTablePreviewHRStyle()}}
          ${prefix} .pricing-table-preview .pricing-table > tbody > tr {${generatePricingTablePreviewStyle(
          "header1",
          10
        )}}
          ${prefix} .pricing-table-preview .pricing-table > tbody > tr.not-selected { background-color: ${
          scope.section.style.header1.color
            ? hexRgba(scope.section.style.header1.color, 5)
            : hexRgba(scope.branding.header1.color, 5)
        } !important; }
          ${prefix} .pricing-table-preview .pricing-table > tbody > tr.not-selected td { color: #b1b1b1 !important; }
          ${prefix} .pricing-table-preview .pricing-table > tbody > tr > td.selectable {
          color: ${
            scope.section.style.header1.color
              ? hexRgba(scope.section.style.header1.color, 0)
              : hexRgba(scope.branding.header1.color, 0)
          }}
          ${prefix} .pricing-table-preview .pricing-table > tbody > tr > td i { color: ${
          scope.section.style.header1.color
            ? hexRgba(scope.section.style.header1.color, 0)
            : hexRgba(scope.branding.header1.color, 0)
        } !important; }
          ${prefix} .pricing-table-preview table.pricing-table-totals tbody {${generatePricingTablePreviewStyle(
          "header1",
          5
        )}}
          ${prefix} .pricing-table-preview table.pricing-table-totals tfoot {${generatePricingTablePreviewStyle(
          "header1",
          10
        )}}
          ${prefix} {${background(scope.section.style)}}
        `);

        return style;
      };

      let style = generateStyleTag();
      style.appendTo($("head"));

      scope.$watch(
        "section.style",
        function (newVal, oldVal) {
          if (!angular.equals(newVal, oldVal) && angular.isDefined(style)) {
            style.remove();
            style = generateStyleTag();
            style.appendTo($("head"));
          }
        },
        true
      );

      scope.$watch("sectionIndex", function (newVal, oldVal) {
        if (!angular.equals(newVal, oldVal) && !oldVal) {
          style.remove();
          style = generateStyleTag();
          style.appendTo($("head"));
        }
      });

      // DESTROY DIRECTIVE
      scope.$on("$destroy", function () {
        style.remove();
      });
    },
  };
}

export default quoteStyles;
